// extracted by mini-css-extract-plugin
export default {"reactInput":"ReactInput_reactInput__mrqUY"};